import { Text, Flex, Img, FlexProps, useTooltip } from 'vvs-uikit'
import { formatNumber } from 'utils/formatBalance'

interface QuestStatItemProps extends FlexProps {
  type: 'quest' | 'exp'
  valuePrefix?: string
  value: number
  tooltip?: string
}

const QuestStatItem = ({ type, value, valuePrefix, tooltip, ...props }: QuestStatItemProps) => {
  const {
    targetRef,
    tooltip: tooltipElement,
    tooltipVisible,
  } = useTooltip(tooltip, { placement: 'top-start', tooltipOffset: [0, 0] })
  return (
    <>
      <Flex alignItems="center" gap="0.5em" px="0.25em" ref={targetRef} {...props}>
        {type === 'quest' && <Img src="/images/vvsGotchi/flag.png" width="17px" />}
        {type === 'exp' && <Img src="/images/vvsGotchi/star.png" width="23px" />}
        <Text color="black" bold fontSize="28px">
          {valuePrefix}
          {formatNumber(value, 0, 3)}
        </Text>
      </Flex>
      {tooltip && tooltipVisible && tooltipElement}
    </>
  )
}

export default QuestStatItem
